import React, { Fragment } from "react";
import { IntlProvider } from "react-intl";
import { useSelector } from "react-redux";
import messages from "../../../utils/messages";

const LanguageProvider = ({ children }) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { selectedLanguage } = commonState;

  return (
    <IntlProvider
      textComponent={Fragment}
      locale={selectedLanguage}
      messages={messages[selectedLanguage]}
    >
      {children}
    </IntlProvider>
  );
};

export default LanguageProvider;
